import React, { Dispatch, SetStateAction } from 'react';
import { Table } from '@tanstack/react-table';
import { FirstPageIcon } from './FirstPageIcon';
import { LastPageIcon } from './LastPageIcon';
import { NextPageIcon } from './NextPageIcon';
import { PreviousPageIcon } from './PreviousPageIcon';
import {
  StyledPagination,
  StyledPageIndex,
  StyledPaginationNavigation,
  StyledPaginationFooter,
  StyledIconButton,
  StyledPage,
} from './Pagination.styles';
import { AllieText } from '../../../Text';

interface DataGridPaginationProps {
  table: Table<unknown>;
  page: number;
  getFirstPage: () => void;
  getPreviousPage: () => void;
  getNextPage: () => void;
  getLastPage: () => void;
  footerItems?: React.ReactNode[];
  rowsPerPageText?: string;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  pageLabel?: string;
}

const PAGE_SIZE_KEY_WORD = '${PAGE_SIZE}';

export const DataGridPagination: React.FC<DataGridPaginationProps> = ({
  table,
  page,
  getFirstPage,
  getPreviousPage,
  getNextPage,
  getLastPage,
  footerItems,
  rowsPerPageText,
  setCurrentPage,
  pageLabel,
}) => {
  const hasPreviousPage = page > 0;
  const hasNextPage = page < table.getPageCount() - 1;
  const fetchSize = table.getRowModel().rows.length;

  const getPagination = (counter: number) => {
    const pages = [];
    for (let index = 0; index < counter; index++) {
      pages.push(
        <StyledPage isSelected={page === index} onClick={() => setCurrentPage(index)}>
          {index + 1}
        </StyledPage>
      );
    }

    const middleEnd = pages.slice(page - 3, page + 3);
    const begenning = pages.slice(0, 6);

    return pages.length >= 7 && page >= 6 ? middleEnd : begenning;
  };

  return (
    <StyledPaginationFooter hasItems={footerItems?.length}>
      <StyledPagination>
        {footerItems}
        {table.getPageCount() > 1 && (
          <>
            <StyledPageIndex>
              <AllieText type="body2" color="neutral-70">
                {pageLabel}
                <strong> {page + 1}</strong>
                {` / ${table.getPageCount()}`}
              </AllieText>
            </StyledPageIndex>
            <StyledPaginationNavigation>
              <StyledIconButton
                corner="rounded-edges-plus"
                id="report"
                allieColor="neutral"
                allieSize="xs"
                allieType="text"
                onClick={getFirstPage}
                disabled={!hasPreviousPage}
              >
                <FirstPageIcon />
              </StyledIconButton>
              <StyledIconButton
                corner="rounded-edges-plus"
                id="report"
                allieColor="neutral"
                allieSize="xs"
                allieType="text"
                onClick={getPreviousPage}
                disabled={!hasPreviousPage}
              >
                <PreviousPageIcon />
              </StyledIconButton>
              <div>{getPagination(table.getPageCount())}</div>
              <StyledIconButton
                corner="rounded-edges-plus"
                id="report"
                allieColor="neutral"
                allieSize="xs"
                allieType="text"
                onClick={getNextPage}
                disabled={!hasNextPage}
              >
                <NextPageIcon />
              </StyledIconButton>
              <StyledIconButton
                corner="rounded-edges-plus"
                id="report"
                allieColor="neutral"
                allieSize="xs"
                allieType="text"
                onClick={getLastPage}
                disabled={!hasNextPage}
              >
                <LastPageIcon />
              </StyledIconButton>
            </StyledPaginationNavigation>
          </>
        )}
      </StyledPagination>
    </StyledPaginationFooter>
  );
};
